import React from 'react';
import './gameQuizTitle.scss';

const GameQuizTitle = ({ title }) => {
  return <div className='game-quiz-title'>{title}</div>;
};

export default GameQuizTitle;
